import { usePlanRoot } from "lib/use-plan-root"
import { Box, Link, ListItem, Stack, Typography } from "@mui/material"
import { navigate } from "lib/routes/navigate"

export function LocationSummary({ item }) {
    const planRoot = usePlanRoot()

    return (
        <ListItem data-cy="zero-u-location-row">
            <Stack direction="row" spacing={0.5}>
                <Box minWidth={20} textAlign="right">
                    <Typography variant="caption" sx={{ fontWeight: "bold" }} data-cy="zero-u-location-count">
                        {item.count}
                    </Typography>
                </Box>
                <Box>
                    <Link onClick={go} data-cy="zero-u-location-link">
                        <Typography variant="caption">in {item.value[0]}</Typography>
                    </Link>
                </Box>
            </Stack>
        </ListItem>
    )

    function go() {
        navigate(`/app/schedules?id=~${planRoot.id}!${item.tasks.items[0].scheduleId.split("!").at(0)}`)
    }
}
